import { Link } from "react-router-dom"
import { Tooltip } from "@mui/material"
import NumberFormat from "react-number-format"
import moment from "moment"
import { BoxFlows } from "./BoxFlows"

export const RowHito = ({ it, draggableProvided, handleOpenEdit, tasksList, setTasksList, handleRemoveTask, usuariosTarea, pathName, handleOpenEditFlow, tarea_mostrar_horas }) => {
    return (
        <tr
            {...draggableProvided.draggableProps}
            ref={draggableProvided.innerRef}
            {...draggableProvided.dragHandleProps}
            style={{
                verticalAlign: 'middle',
                color: it.estado === 'completado' ? 'green' : ''
            }}>

            {pathName === 'tasks' ?
                <td style={{ verticalAlign: 'middle' }}>
                    <div style={{ width: '200px' }}>
                        <Link
                            className="p-link-project-name"
                            target="_black"
                            to={`/ppto/${it.id_proyecto}`}
                        >
                            {it.project_name}
                        </Link>
                    </div>
                </td> : ''
            }

            <td colSpan={3}
                style=
                {{
                    verticalAlign: 'middle',
                    width: '400px',
                    height: '55px'
                }}>
                <div className="d-flex flex-column justify-content-center align-items-start">
                    <div className="d-flex justify-content-between align-items-center"
                        style={{
                            width: '100%',
                            border: 'none',
                            color: (it?.tipo === 'hito' || it?.subs.length > 0) ? '#8E24AA' : '#78717A',
                        }}>
                        <Link
                            to=""
                            onClick={() => handleOpenEdit(it?.id)}
                            className={`d-flex justify-content-start align-items-center 
                                ${it.estado === 'completado' ? 'p-link-hitos-done' : 'p-link-hitos'}`}
                        >
                            <div style={{
                                fontSize: '14px',
                                textAlign: 'left',
                            }}>
                                {it?.prioridad === 'critica' ?
                                    <span style={{ color: 'red' }}>
                                        {`${it?.orden ? `(${it?.orden})` : ''} ${it?.tipo === 'hito' ? 'Hito: ' : ''} ${it.nombre}`}
                                    </span>
                                    :
                                    <span>
                                        {`${it?.orden ? `(${it?.orden})` : ''} ${it?.tipo === 'hito' ? 'Hito: ' : ''} ${it.nombre}`}
                                    </span>
                                }
                            </div>

                            {it.estado === 'completado' ?
                                <Tooltip title="Hito completado">
                                    <i className="bi bi-check-circle-fill ms-1" style={{ fontSize: '14px' }}></i>
                                </Tooltip> : ''
                            }

                        </Link>

                        {(it.info_flow.length > 0) &&
                            <Link
                                to=""
                                className="p-link-hitos ms-2 d-flex justify-content-start align-items-end mt-[2px]"
                                onClick={() => handleOpenEditFlow(it)}
                            >
                                {it.info_flow.length === 1 ?
                                    <span className="d-flex flex-column justify-content-start align-items-end">
                                        {it?.info_flow.map(itf => <BoxFlows flow={itf} />)}
                                    </span>
                                    :
                                    <span>
                                        <i className="bi bi-link-45deg text-[12px]"></i>
                                        <span className="ms-1">Varios flujos</span>
                                    </span>
                                }
                            </Link>
                        }

                    </div>

                    {it?.subs.length > 0 &&
                        <Link to=""
                            onClick={() => {
                                const listUpdated2 = tasksList.map(it2 => {
                                    if (it2.id === it?.id) {
                                        return {
                                            ...it2,
                                            show_subs: !it2.show_subs
                                        }
                                    }

                                    return it2
                                })

                                setTasksList(listUpdated2)
                            }}
                            className="d-flex align-items-start d-flex align-items-center p-link-info-task">
                            <i className="bi bi-list-check ms-1" style={{ fontSize: '16px' }}></i>
                            <span style={{ fontSize: '12px', marginLeft: '2px' }}>
                                {it?.subs.length} {`${it?.tipo === 'hito' ? `${it?.subs.length === 1 ? 'tarea' : 'tareas'}` : `${it?.subs.length === 1 ? 'subtarea' : 'subtareas'}`}`}
                            </span>
                        </Link>
                    }

                </div>
            </td>
            <td className="text-center">
                {/* {(usuariosTarea.find(ut => ut.id === it?.id_responsable))?.nombre || ''} */}
            </td>
            <td className="text-center">
                {/* {(usuariosTarea.find(ut => ut.id === it?.id_responsable_seguimiento))?.nombre || ''} */}
            </td>

            {
                tarea_mostrar_horas ?
                    <>
                        <td className="text-center">
                            <NumberFormat
                                displayType={'text'}
                                className="text-end"
                                value={it.hora_estimada || 0}
                                thousandSeparator=','
                                decimalSeparator='.'
                                suffix=" hrs."
                                decimalScale={0}
                                fixedDecimalScale={0}
                            />
                        </td>
                        <td className="text-center">
                            <NumberFormat
                                displayType={'text'}
                                className="text-end"
                                value={it.hora_real || 0}
                                thousandSeparator=','
                                decimalSeparator='.'
                                suffix=" hrs."
                                decimalScale={0}
                                fixedDecimalScale={0}
                            />
                        </td>
                    </>
                    : ''
            }

            <td className="text-center">
                {it?.subs?.length > 0 ?
                    // <span>{it?.fecha_fin ? moment(it?.fecha_fin).diff(moment(it?.fecha_inicio), 'days') : 0} Días</span>
                    <NumberFormat
                        displayType={'text'}
                        className="text-end"
                        value={it.dias || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        suffix=" días"
                        decimalScale={0}
                        fixedDecimalScale={0}
                    />
                    :
                    <NumberFormat
                        displayType={'text'}
                        className="text-end"
                        value={it.dias || 0}
                        thousandSeparator=','
                        decimalSeparator='.'
                        suffix=" días"
                        decimalScale={0}
                        fixedDecimalScale={0}
                    />
                }
            </td>
            <td className="text-center">
                {it?.fecha_inicio ? moment(it?.fecha_inicio).format('DD-MM-YYYY') : '---'}
            </td>
            <td className="text-center"
                style={{
                    color: (moment(it?.fecha_fin).format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD') && it.estado !== 'completado') ?
                        'red' : ''
                }}>
                {it?.fecha_fin ? moment(it?.fecha_fin).format('DD-MM-YYYY') : '---'}{' '}

                {/* {it?.fecha_fin ?
                    `(${moment(it?.fecha_fin).diff(moment(it?.fecha_inicio), 'days') + 1}d)`
                    :
                    ''
                } */}
            </td>
            <td className="text-center"
                style={{
                    color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
                    textTransform: 'uppercase'
                }}>
                {it?.estado || '---'}
            </td>
            {/* <td className="text-center">
                {it?.prioridad === 'critica' ?
                    <span style={{ color: 'red' }}>{it?.prioridad || '---'}</span>
                    :
                    <span>{it?.prioridad || '---'}</span>
                }
            </td> */}
            <td className="text-start" style={{ verticalAlign: 'middle' }}>
                <Tooltip title="Eliminar hito">
                    <Link to="" onClick={() => handleRemoveTask(it, 'hito')}>
                        <i className="bi bi-trash" style={{ color: 'gray', fontSize: '14px' }}></i>
                    </Link>
                </Tooltip>
            </td>
        </tr >
    )
}